module.exports = __webpack_public_path__ + "static/img/repayment.de091622.png";